module.exports = __webpack_public_path__ + "static/img/shipping.1a222af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shipping.png
// module id = 442
// module chunks = 169